import { Geometry } from '@model';

const siteContentBaseUrl = import.meta.env.VITE_SITE_CONTENT_BASE_URL;

export const fetchCachedGeometries = async (): Promise<Geometry[]> => {
  return await fetch(`${siteContentBaseUrl}/geometries.json`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }).then((res) => res.json());
};
